import { ServiceFetch } from '../service-fetch'

export default class PointExpireModel extends ServiceFetch {
    generatePointExpireLastCode = (data) => this.authFetch({
        url: 'point-expire/generatePointExpireLastCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getPointExpireBy = (data) => this.authFetch({
        url: 'point-expire/getPointExpireBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getPointExpireByCode = (data) => this.authFetch({
        url: 'point-expire/getPointExpireByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    checkDuplicate = (data) => this.authFetch({
        url: 'point-expire/checkDuplicate',
        method: 'POST',
        body: JSON.stringify(data),
    })

    approvePointExpireBy = (data) => this.authFetch({
        url: 'point-expire/approvePointExpireBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    insertPointExpire = (data) => this.authFetch({
        url: 'point-expire/insertPointExpire',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updatePointExpireBy = (data) => this.authFetch({
        url: 'point-expire/updatePointExpireBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    deletePointExpireByCode = (data) => this.authFetch({
        url: 'point-expire/deletePointExpireByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}
